<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <h6>Dados gravados em {{ atendimento.created_at_f }}</h6>
          <h6 v-show="atendimento.updated_at">Última edição em {{ atendimento.updated_at_f }}</h6>
        </div>
        <div class="col-md-12">
          <label>Unidade</label>
          <input type="text" class="form-control" v-model="atendimento.unidade.nome" disabled />
        </div>
        <div class="col-md-12">
          <label>Botão</label>
          <input type="text" class="form-control" v-model="atendimento.botao.nome" disabled />
        </div>
        <div class="col-md-6">
          <label>Data inicial</label>
          <input type="text" class="form-control" v-model="atendimento.data_inicio_f" disabled />
        </div>
        <div class="col-md-6">
          <label>Data final</label>
          <input type="text" class="form-control" v-model="atendimento.data_fim_f" disabled />
        </div>
        <div class="col-md-4">
          <label>Senha</label>
          <input type="text" class="form-control" v-model="atendimento.senha" disabled />
        </div>
        <div class="col-md-4">
          <label>ID central</label>
          <input type="text" class="form-control" v-model="atendimento.id" disabled />
        </div>
        <div class="col-md-4">
          <label>ID original</label>
          <input type="text" class="form-control" v-model="atendimento.original_id" disabled />
        </div>
      </div>
      <div class="row d-flex justify-content-center align-items-center my-3">
        <div class="col-md-8 card text-center py-1" style="border: solid 1px #999;">
          <h3>Início</h3>
        </div>
        <div class="col-md-8 card text-center py-1" style="border: solid 1px #999;" v-for="(setor, index) in atendimento_setor">
          <p><b>Entrada no setor: </b>{{ setor.data_entrada_f }}</p>
          <p><b>Última chamada: </b>{{ setor.data_ultima_chamada_f }}</p>
          <p><b>Inicio: </b>{{ setor.data_inicio_f }}</p>
          <span><b>Saída do setor: </b>{{ setor.data_fim_f }}</span>
          <hr>
          <p><b>Prioridade: </b>{{ setor.prioridade_f }}</p>
          <p><b>Status: </b>{{ setor.status_text }}</p>
          <p><b>Classificacao: </b>{{ setor.classificacao.nome }}</p>
          <p><b>Setor: </b>{{ setor.setor.nome }}</p>
          <p v-if="setor.local_id"><b>Local: </b>{{ setor.local.nome }}</p>
        </div>
        <div class="col-md-8 card text-center py-1" style="border: solid 1px #999;" v-if="atendimento.data_fim">
          <h3>Fim</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 text-left d-flex align-items-end">
          <h5>Última sincronização realizada em {{ atendimento.sincronizacao_f }}</h5>
        </div>
        <div class="col-md-6 text-right">
          <hr />
          <router-link to="/atendimentos" class="btn btn-back">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      atendimento: {},
      atendimento_setor: {},
    };
  },
  computed: {},
  methods: {
    getAtendimento: function (id) {
      const self = this;
      const api = self.$store.state.api + "atendimentos/" + id + '?with[]=unidade&with[]=botao';

      axios
        .get(api)
        .then((response) => {
          if(response.data.data[0])
          {
            self.atendimento = response.data.data[0];

            self.atendimento.senha = self.atendimento.prefixo + self.atendimento.senha;

            self.getAtendimentoSetor(id, self.atendimento.unidade_id)

            self.setLoader(30);
          }else{
            this.$router.push("/no-item");
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getAtendimentoSetor: function (id, unidade) {
      const self = this;
      const api = self.$store.state.api + `atendimento_setores?atendimento_id=${id}&unidade_id=${unidade}&with[]=classificacao&with[]=local&with[]=setor`;

      axios
        .get(api)
        .then((response) => {
          console.clear();
          console.log(response.data.data);

          self.atendimento_setor = response.data.data;

          self.setLoader(30);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.setLoader(40);

    if (id) {
      self.getAtendimento(id);
    } else {
      self.setLoader(40);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>